import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";
import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

const TreeNodeFragment = gql`
	fragment TreeNode on SupportRequestTreeNode {
		_id
		title
		levelName
		status
		disabled
		readonly
		bold
		badge {
			title
			variant
		}
	}
`;

export interface TreeNode {
	_id: string;
	title: string;
	levelName: string;
	status: string;
	disabled: boolean;
	readonly: boolean;
	bold: boolean;
	badge: {
		title?: number;
		variant?: string;
	};
	list?: TreeNode[];
}

export interface IGetSupportRequestsTreeResult {
	locationId: string;
	userId: string;
	myTree: {
		currentCommissionCycle: TreeNode[];
		previousSupport: TreeNode[];
	};
	positionsTree: TreeNode[];
}

export async function getSupportRequestsTree({ locationId }: { locationId: string }) {
	const query = gql`
		query getSupportRequestTree($locationId: String!) {
			getSupportRequestTree(locationId: $locationId) {
				locationId
				userId
				myTree {
					currentCommissionCycle {
						...TreeNode # CommissionCycle
						list {
							...TreeNode # Payperiod
							list {
								...TreeNode # Position
							}
						}
					}
					previousSupport {
						...TreeNode # Year
						list {
							...TreeNode # CommissionCycle
							list {
								...TreeNode # Payperiod
								list {
									...TreeNode # Position
								}
							}
						}
					}
				}
				positionsTree {
					...TreeNode # Year
					list {
						...TreeNode # CommissionCycle
						list {
							...TreeNode # Payperiod
							list {
								...TreeNode # Position
								list {
									...TreeNode # User
								}
							}
						}
					}
				}
			}
		}
		${TreeNodeFragment}
	`;

	const variables = {
		locationId,
	};

	try {
		const result: GraphqlQueryResponse<"getSupportRequestTree", IGetSupportRequestsTreeResult> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return result.data.data?.getSupportRequestTree;
	} catch (error) {
		errorLogger(error as Error);
		return null;
	}
}
